<template>
  <!-- Tabbed form -->
  <v-form v-if="useTabbedView && tabsHeaders !== null" ref="form">
    <v-tabs v-model="currentTabIndex">
      <v-tab v-for="(tab, index) in tabbedForms" :key="index" ripple>
        {{ tab.header }}
      </v-tab>
      <v-tabs-items>
        <v-tab-item v-for="(tab, index) in tabbedForms" :key="index">
          <v-layout v-if="tab.schema != null && tab.schema !== {}" row wrap>
            <ReactiveDynamicWidget
              v-for="(item, key) in tab.schema"
              v-show="item.hidden != true"
              :ref="key"
              :key="refreshSnapshots[key].updateKey"
              v-model="currentFormValue"
              :hidden="schema.hidden"
              :input-key="key"
              :schema="item"
              :current-entity-id="entityId"
              :current-entry-id="entryId"
              :add-button-clicked="addButtonClicked"
              @inputChange="updateWidgetValue"
              @buttonClicked="$emit('buttonClicked', $event)"
              @addedRow="$emit('addedRow', $event)"
              @deleteItem="$emit('deleteItem', $event)"
              @indexChange="$emit('indexChange', $event)"
              @iconClicked="$emit('iconClicked', $event)"
              @validateComplexWidget="validateComplexWidget"
              @alert="$emit('alert', $event)"
              @hide="hide"
              @show="show"
              @make-readonly="makeReadonly"
              @transmit="transmit"
              @getItems="getItems"
              @refreshRequested="requestRefresh"
              @refreshFormRequested="refreshFormRequest"
            ></ReactiveDynamicWidget>
          </v-layout>
          <v-layout v-if="showNavigationButtons" justify-end class="mr-10">
            <v-icon color="info" @click.stop="prevTab">arrow_back_ios</v-icon>
            <v-icon color="info" @click.stop="nextTab"
              >arrow_forward_ios</v-icon
            >
          </v-layout>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-form>

  <!-- Simple form -->
  <v-form v-else ref="form">
    <v-layout row wrap>
      <ReactiveDynamicWidget
        v-for="(item, key) in schema"
        v-show="item.hidden != true"
        :ref="key"
        :key="refreshSnapshots[key].updateKey"
        v-model="currentFormValue"
        :hidden="schema.hidden"
        :input-key="key"
        :schema="item"
        :current-entity-id="entityId"
        :current-entry-id="entryId"
        :add-button-clicked="addButtonClicked"
        @inputChange="updateWidgetValue"
        @buttonClicked="$emit('buttonClicked', $event)"
        @addedRow="$emit('addedRow', $event)"
        @deleteItem="$emit('deleteItem', $event)"
        @modifyItem="$emit('modifyItem', $event)"
        @indexChange="$emit('indexChange', $event)"
        @iconClicked="$emit('iconClicked', $event)"
        @validateComplexWidget="validateComplexWidget"
        @alert="$emit('alert', $event)"
        @hide="hide"
        @show="show"
        @make-readonly="makeReadonly"
        @transmit="transmit"
        @getItems="getItems"
        @refreshRequested="requestRefresh"
        @refreshFormRequested="refreshFormRequest"
        @refShowList="$emit('refShowList')"
        @refClearSelection="$emit('refClearSelection')"
      ></ReactiveDynamicWidget>

      <!-- <v-btn v-if="refMode" icon @click="$emit('refShowList')">
        <v-icon>find_replace</v-icon>
      </v-btn>
      <v-btn v-if="refMode" icon @click="$emit('refClearSelection')">
        <v-icon>clear</v-icon>
      </v-btn> -->
    </v-layout>
  </v-form>
</template>

<script>
import ReactiveDynamicWidget from './ReactiveDynamicWidget'
import axios from 'axios'
import RefreshService from './RefreshService.js'

export default {
  name: 'RdForm',
  components: {
    ReactiveDynamicWidget
  },
  props: {
    schema: {
      type: Object,
      required: true
    },
    refMode: {
      type: Boolean,
      default: false
    },
    useTabbedView: {
      type: Boolean,
      required: false,
      default: false
    },
    entityId: {
      type: String,
      required: false,
      default: null
    },
    entryId: {
      type: String,
      required: false,
      default: null
    },
    tabsHeaders: {
      type: Array,
      required: false,
      default: null
    },
    entityMetaData: {
      type: Object,
      required: false,
      default: null
    },
    addButtonClicked: {
      type: Number,
      required: false,
      default: null
    },
    showNavigationButtons: {
      type: Boolean,
      default: true
    },
    autoHandleRefreshRequests: {
      type: Boolean,
      default: true
      //tells RDForm that it should handle the refresh requests by itself and not upcast them
    },
    value: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      currentFormValue: this.value !== null ? this.value : {},
      currentTabIndex: 0,
      complexWidgetsValidationSchema: {},
      refreshSnapshots: {},
      refreshService: null
    }
  },
  computed: {
    tabbedForms: function() {
      let tabs = []
      let currentTabIndex = 0
      Object.keys(this.schema).forEach((key) => {
        if (tabs[currentTabIndex] == null) {
          tabs[currentTabIndex] = {}
          tabs[currentTabIndex].header = this.tabsHeaders[currentTabIndex]
          tabs[currentTabIndex].schema = {}
        }
        if (
          this.schema[key].hidden == null ||
          this.schema[key].hidden === false
        ) {
          tabs[currentTabIndex].schema[key] = this.schema[key]
        }
        if (this.schema[key].tabSplitAfter) currentTabIndex++
      })
      let validTabs = []
      for (var i in tabs) {
        if (
          Object.keys(tabs[i].schema).length > 0 &&
          tabs[i].schema.constructor === Object
        )
          validTabs.push(tabs[i])
      }
      // console.log("valid tabs: " + JSON.stringify(validTabs));
      return validTabs
    }
  },
  watch: {
    currentFormValue: {
      deep: true,
      handler: function() {
        //console.log("currentFormValue " + JSON.stringify(this.currentFormValue))
        this.$emit('input', this.currentFormValue)
      }
    }
  },

  created: function() {
    for (var x in this.schema) {
      if (this.schema[x].hide != undefined) {
        if (
          (this.schema[x].type === 'checkbox' ||
            this.schema[x].type === 'select' ||
            this.schema[x].type === 'radiogroup') &&
          this.currentFormValue[x] == undefined
        ) {
          this.hide(this.schema[x].hide, false)
        }
        if (this.currentFormValue[x] != undefined) {
          this.hide(this.schema[x].hide, this.currentFormValue[x])
        }
      }
      if (this.schema[x].show != undefined) {
        if (
          (this.schema[x].type === 'checkbox' ||
            this.schema[x].type === 'select' ||
            this.schema[x].type === 'radiogroup') &&
          this.currentFormValue[x] == undefined
        ) {
          this.show(this.schema[x].show, false)
        }
        if (this.currentFormValue[x] != undefined) {
          this.show(this.schema[x].show, this.currentFormValue[x])
        }
      }
      if (this.schema[x].type === 'ref' && this.schema[x].required == true) {
        if (this.currentFormValue[x] != null)
          this.complexWidgetsValidationSchema[x] = true
        else this.complexWidgetsValidationSchema[x] = false
      } else if (this.schema[x].type === 'function' && this.entryId != null) {
        // function args adjustments: the widget needs the values, not the names
        if (
          this.schema[x].functionArgs != null &&
          Array.isArray(this.schema[x].functionArgs)
        ) {
          this.schema[x].functionArgs = this.getArgsWithValues(
            this.schema[x].functionArgs,
            this.currentFormValue
          )
        }
      }
    }
    var keys = []
    Object.keys(this.schema).forEach((key) => keys.push(key))
    try {
      this.refreshService = new RefreshService(this.refreshSnapshots, keys)
    } catch (ex) {
      console.log('Could not initialize refresh service: ')
      console.log(ex)
    }
  },
  methods: {
    calculateComplexWidgetsValidationState: function() {
      var result = true
      Object.keys(this.complexWidgetsValidationSchema).forEach((key) => {
        result = result && this.complexWidgetsValidationSchema[key]
      })
      return result
    },
    validateComplexWidget: function(validationState, key) {
      if (this.complexWidgetsValidationSchema == null)
        this.complexWidgetsValidationSchema = {}
      this.complexWidgetsValidationSchema[key] = validationState
    },
    updateWidgetValue: function(newVal, key) {
      this.currentFormValue[key] = newVal
      this.$emit('onFormUpdate', newVal, key)
      // this.$emit("formValid", this.validateForm());
    },
    prevTab: function() {
      if (this.currentTabIndex == 0)
        this.currentTabIndex = this.tabsHeaders.length - 1
      else this.currentTabIndex -= 1
    },
    nextTab: function() {
      if (this.currentTabIndex == this.tabsHeaders.length - 1)
        this.currentTabIndex = 0
      else this.currentTabIndex += 1
    },

    show: function(showSchema, currentValue) {
      Object.keys(showSchema).forEach((targetValue) => {
        if (String(currentValue) === targetValue) {
          showSchema[targetValue].forEach((targetKey) => {
            this.showKey(targetKey)
          })
        } else {
          showSchema[targetValue].forEach((targetKey) => {
            if (
              showSchema[currentValue] != null &&
              !showSchema[currentValue].includes(targetKey)
            ) {
              this.hideKey(targetKey)
            }
          })
        }
      })
      if (showSchema[currentValue] == null) {
        Object.keys(showSchema).forEach((targetValue) => {
          showSchema[targetValue].forEach((targetKey) => {
            this.hideKey(targetKey)
          })
        })
      }
    },
    /**
     * Handles the hide request of a widget.
     * Syntax:
     * widget: {
     *    type: '....',
     *    hide: {
     *        targetValue1: ["targetKey1", "targetKey2"],
     *        targetValue2: ["targetKey3", "targetKey4"]
     *    }
     * }
     * Interpretation: if the widget's current value is "targetValue1" then hide widgets: "targetKey1" and "targetKet2".
     */
    hide: function(hideSchema, currentValue) {
      Object.keys(hideSchema).forEach((targetValue) => {
        if (String(currentValue) === targetValue) {
          hideSchema[targetValue].forEach((targetKey) => {
            this.hideKey(targetKey)
          })
        } else {
          hideSchema[targetValue].forEach((targetKey) => {
            if (
              hideSchema[currentValue] != null &&
              !hideSchema[currentValue].includes(targetKey)
            ) {
              this.showKey(targetKey)
            }
          })
        }
      })
      if (hideSchema[currentValue] == null) {
        Object.keys(hideSchema).forEach((targetValue) => {
          hideSchema[targetValue].forEach((targetKey) => {
            this.showKey(targetKey)
          })
        })
      }
    },
    makeReadonly: function(readonlySchema, currentValue) {
      Object.keys(readonlySchema).forEach((targetValue) => {
        if (String(currentValue) === targetValue) {
          readonlySchema[targetValue].forEach((targetKey) => {
            this.makeKeyReadonly(targetKey)
          })
        } else {
          readonlySchema[targetValue].forEach((targetKey) => {
            if (
              readonlySchema[currentValue] != null &&
              !readonlySchema[currentValue].includes(targetKey)
            ) {
              this.makeKeyNotReadonly(targetKey)
            }
          })
        }
      })
    },
    hideKey: function(targetKey) {
      if (
        this.schema != null &&
        this.schema[targetKey] != null &&
        (this.schema[targetKey].hidden == null ||
          this.schema[targetKey].hidden === false)
      ) {
        this.currentFormValue[targetKey] = null
        this.$set(this.schema[targetKey], 'hidden', true)
      }
    },
    showKey: function(targetKey) {
      if (
        this.schema != null &&
        this.schema[targetKey] != null &&
        !(
          this.schema[targetKey].hidden == null ||
          this.schema[targetKey].hidden === false
        )
      ) {
        this.currentFormValue[targetKey] = null
        this.$set(this.schema[targetKey], 'hidden', false)
      }
    },
    /**
     * Makes a certain key readonly in the form's schema.
     */
    makeKeyReadonly: function(targetKey) {
      if (this.schema != null && this.schema[targetKey] != null) {
        this.$set(this.schema[targetKey], 'readonly', true)
        console.log(`Make ${targetKey} readonly`)
      }
    },
    /**
     * Disables the readonly property of a key in the form's schema.
     */
    makeKeyNotReadonly: function(targetKey) {
      if (this.schema != null && this.schema[targetKey] != null) {
        this.$set(this.schema[targetKey], 'readonly', false)
      }
    },

    transmit: function(comp, value) {
      for (var key in this.schema) {
        if (this.schema.hasOwnProperty(key)) {
          if (key == comp) {
            this.$set(this.value, key, value) //modify value(for text,checks etc)
            this.$set(this.schema[key], 'transmited', value) //set another specifically for transmited value
          }
        }
      }
    },
    getItems: function(url, comp) {
      var data = axios.get(url).then((response) => response.data)
      for (var i in data) {
        this.schema[comp].items.push(data[i])
      }
    },
    validateForm: function() {
      if (this.$refs.form == null) return false
      return (
        this.$refs.form.validate() &&
        this.calculateComplexWidgetsValidationState()
      )
    },
    /**
     * @param {Array} targets - The array of keys to refresh.
     * @param {String} invoker - The key of the widget who requested the refresh.
     * @param invokerSnapshotValue - The current value of the invoker.
     */
    requestRefresh(targets, invokerWidget, invokerSnapshotValue) {
      if (this.autoHandleRefreshRequests) {
        // console.log(
        //   `Received refresh request for ${targets} from ${invokerWidget}`
        // );
        if (!Array.isArray(targets)) return
        targets.forEach((key) => {
          if (key == null || this.schema[key] == null) return
          try {
            // recalculam prop-urile din schema pentru fiecare target tip function
            if (this.schema[key].type === 'function' && this.entryId !== null) {
              if (
                this.schema[key].functionArgs != null &&
                Array.isArray(this.schema[key].functionArgs)
              ) {
                this.schema[key].functionArgs = this.getArgsWithValues(
                  this.schema[key].functionArgs,
                  this.currentFormValue
                )
              }
            }
            // console.log("Updated function args for: " + key + " to: ");
            // console.log(this.schema[key].functionArgs);
            this.refreshService.refresh(key)
            if (this.$refs[key]) this.$refs[key][0].forceUpdate()
          } catch (ex) {
            console.log('Could not fulfill refresh request: ')
            console.log(ex)
          }
        })
      } else {
        // TODO: Avem ce sa facem cu emitul mai departe?
        this.$emit(
          'refreshRequested',
          targets,
          invokerWidget,
          invokerSnapshotValue
        )
      }
    },
    refreshFormRequest() {
      this.$emit('refreshFormRequested')
    },
    /**
     * @param {Object} args - The args list (could be an array of objects, or an array of strings)
     * @example
     *    getArgsWithValues(['cropYear', 'type']) --> [{key: 'cropYear', value: 2020}, {key: 'type', value: 'S'}]
     */
    getArgsWithValues(args, formValues) {
      if (args == null || !Array.isArray(args)) return null
      var argsWithValues = []
      args.forEach((arg) => {
        if (typeof arg === 'string') {
          argsWithValues.push({ key: arg, value: formValues[arg] })
        } else if (typeof arg === 'object') {
          // arg already has a value assigned
          argsWithValues.push({ key: arg.key, value: formValues[arg.key] })
        }
      })
      return argsWithValues
    }
  }
}
</script>

<style scoped></style>
